module.exports = __webpack_public_path__ + "static/media/border-right.d70cf70c.png";